import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "FormLogin" }
const _hoisted_2 = { class: "form-login__social" }
const _hoisted_3 = { class: "form-login__fields" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "form-login__signup" }

import { ref } from 'vue';
import { RequestError } from 'Api';

// Store
import { useLogin } from 'Store';

// Auth
import { ILoginData } from 'Auth';

// Components
import BaseForm from 'Components/Base/BaseForm.vue';
import BaseFormInput from 'Components/Base/BaseFormInput.vue';
import { BaseButton } from 'Components/Base/BaseButton';
import BaseFormGroup from 'Components/Base/BaseFormGroup.vue';
import { BaseNotificationInline } from 'Components/Base/BaseNotificationInline';
import AuthSocialButtons from 'Components/AuthSocialButtons/AuthSocialButtons.vue';

// Composables
import { useFormLogin } from './composables/useFormLogin';

// emits

export default /*@__PURE__*/_defineComponent({
  __name: 'FormLogin',
  props: {
    redirectOnSignup: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

// props
const props = __props;

// initialization
const {
  FormBeforeSendError,
  $v,
  formModel,
  formSend,
  isFormLoading,
  formSendErrorMessage,
  isFormSendSuccess,
} = useFormLogin();

const passwordType = ref('password');

async function onLoginSuccess(loginData: ILoginData) {
  useLogin()
    .setLoginData(loginData);
  emit('success', loginData);
}

function onSocialSuccess(loginData: ILoginData) {
  // if first login, it needs to complete signup so redirect to sign-up-social which is on vue2
  if (loginData.isFirstLogin) {
    window.location.href = '/sign-up-social';
  } else {
    onLoginSuccess(loginData);
  }
}

function showHidePassword() {
  if (passwordType.value === 'password') {
    passwordType.value = 'text';
  } else {
    passwordType.value = 'password';
  }
}

async function send() {
  try {
    const loginData = await formSend();
    await onLoginSuccess(loginData as ILoginData);
  } catch (error) {
    if (!(error instanceof FormBeforeSendError) && !(error as RequestError).handled) throw error;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AuthSocialButtons, { onSuccess: onSocialSuccess })
    ]),
    _createVNode(BaseForm, {
      "keep-loading-send-on-success": "",
      "send-loading": _unref(isFormLoading),
      "send-success": _unref(isFormSendSuccess),
      class: "form-login"
    }, {
      default: _withCtx(({ isFormSendLoading }) => [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "form-login__or-arrow" }, [
          _createElementVNode("h6", { class: "form-login__or-arrow-title" }, "or")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(BaseFormGroup, {
            class: "form-login__field",
            label: "Email",
            validation: _unref($v).email,
            required: ""
          }, {
            default: _withCtx(({ isFieldError }) => [
              _createVNode(BaseFormInput, {
                modelValue: _unref(formModel).data.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).data.email) = $event)),
                "auto-focused": "",
                class: "form-login__input",
                placeholder: "Email Address",
                "is-error": isFieldError,
                disabled: isFormSendLoading
              }, null, 8, ["modelValue", "is-error", "disabled"])
            ]),
            _: 2
          }, 1032, ["validation"]),
          _createVNode(BaseFormGroup, {
            class: "form-login__field form-login__password-field",
            label: "Password",
            validation: _unref($v).password,
            required: ""
          }, {
            default: _withCtx(({ isFieldError }) => [
              _createVNode(BaseFormInput, {
                modelValue: _unref(formModel).data.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).data.password) = $event)),
                class: "form-login__input",
                placeholder: "Password (min. 8 characters)",
                type: passwordType.value,
                disabled: isFormSendLoading,
                "is-error": isFieldError,
                prepend: ""
              }, {
                prepend: _withCtx(() => [
                  (_unref(formModel).data.password)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "form-login__password-button",
                        onClick: showHidePassword
                      }, [
                        (passwordType.value === 'password')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "form-login__password-button-icon",
                              innerHTML: require(`!!raw-loader!images/svg-icons/eye-slash.svg`).default
                            }, null, 8, _hoisted_4))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "form-login__password-button-icon",
                              innerHTML: require(`!!raw-loader!images/svg-icons/eye.svg`).default
                            }, null, 8, _hoisted_5))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["modelValue", "type", "disabled", "is-error"])
            ]),
            _: 2
          }, 1032, ["validation"]),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "form-login__label-link" }, [
            _createElementVNode("a", {
              href: "/reset-password",
              class: "link-2 small-link"
            }, "Forgot password")
          ], -1)),
          _createVNode(_unref(BaseNotificationInline), {
            class: "form-login__notification",
            show: Boolean(_unref(formSendErrorMessage))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(formSendErrorMessage) }, null, 8, _hoisted_6)
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(BaseButton), {
            type: "submit",
            color: "primary",
            loading: isFormSendLoading,
            tabindex: "0",
            large: "",
            class: "form-login__button",
            onClick: _withModifiers(send, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "form-login__envelope-icon svg-icon",
                innerHTML: require(`!!raw-loader!images/svg-icons/fa-envelope.svg`).default
              }, null, 8, _hoisted_7),
              _cache[2] || (_cache[2] = _createTextVNode(" Log In with Email "))
            ]),
            _: 2
          }, 1032, ["loading"]),
          _createElementVNode("div", _hoisted_8, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "form-login__signup-text small-text" }, "Don’t have an account?", -1)),
            _createVNode(_unref(BaseButton), {
              tag: "a",
              color: "transparent",
              href: '/sign-up' + (props.redirectOnSignup ? '?redirect=' + props.redirectOnSignup : ''),
              tabindex: "0",
              large: ""
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Sign Up ")
              ])),
              _: 1
            }, 8, ["href"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["send-loading", "send-success"])
  ]))
}
}

})